import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { endpoints } from 'src/app/constants/endpoints';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';
import User from 'src/modules/user/types/user';

@Component({
    selector: 'app-delete-account-confirm',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    standalone: false
})
export class DeleteAccountConfirm {
  constructor(
    public dialogRef: MatDialogRef<DeleteAccountConfirm>,
    protected Api: ApiService,
    @Inject(MAT_DIALOG_DATA) public data: User
  ) {}

  public async confirm(user: User) {
    const endpoint = `${endpoints.user.deleteUser}/${user.id}`;
    const result = await this.Api.delete(endpoint, environment.userAdminUrl);
    this.dialogRef.close(result);
  }
}
